
import { UserToken, UserData, AppAccessGranted } from '../stores/LoggedUser';
import { EventSelected } from '../stores/EventSelected';

const user_tkn = 'fday_user_tkn';
const user_data = 'fday_user_data';
const app_access_granted = 'fday_app_access_granted';
const event_data = 'fday_app_event';

function initMonitor() {
    console.log('Init monitor');
    
    console.log('check localstorage for logged user');
    let tkn = localStorage.getItem(user_tkn);
    if( tkn ){
        UserToken.set(tkn);
    }

    let udata = localStorage.getItem(user_data);
    if( udata ){
        UserData.set(JSON.parse(udata));
    }

    let appaccess = localStorage.getItem(app_access_granted);
    if( appaccess ){
        AppAccessGranted.set(appaccess);
    }

    let event = localStorage.getItem(event_data);
    if( event ){
        EventSelected.set(JSON.parse(event));
    }

}

function keepStoreInSync(){
    // update localStorage when the data in the store changes 
    const utknUnsubscribe = UserToken.subscribe(tkn => {
        console.log('writing to user_tkn');
        console.log(tkn);
        localStorage.setItem(user_tkn, tkn );
    });

    const udataUnsubscribe = UserData.subscribe(data => {
        console.log('writing to user_data');
        console.log(data);
        localStorage.setItem(user_data, JSON.stringify(data) );
    });

    const appaccessUnsubscribe = AppAccessGranted.subscribe(data => {
        console.log('writing to app_access_granted');
        console.log(data);
        localStorage.setItem(app_access_granted, data );
    });

    const eventUnsubscribe = EventSelected.subscribe(data => {
        console.log('writing to event data');
        console.log(data);
        localStorage.setItem(event_data, JSON.stringify(data) );
    });
}

function logout(){
    AppAccessGranted.set('false');
    UserToken.set('');
    UserData.set({});
    EventSelected.set({});
    window.location.href = '#/';
}

export {
    initMonitor,
    keepStoreInSync,
    logout
}


